var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlertIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 22,
  viewBox: "0 0 25 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M24.0536 14.938L15.6307 1.63662C14.9219 0.615034 13.7439 0 12.5034 0C11.2629 0 10.085 0.60461 9.34485 1.66789L0.963708 14.9172C-0.0995717 16.4391 -0.297634 18.2634 0.442492 19.6707C1.17219 21.078 2.70457 21.8806 4.62264 21.8806H20.3842C22.3127 21.8806 23.8346 21.078 24.5643 19.6707C25.294 18.2634 25.096 16.4496 24.0536 14.938ZM11.461 6.25459C11.461 5.68125 11.9301 5.21216 12.5034 5.21216C13.0768 5.21216 13.5459 5.68125 13.5459 6.25459V12.5092C13.5459 13.0825 13.0768 13.5516 12.5034 13.5516C11.9301 13.5516 11.461 13.0825 11.461 12.5092V6.25459ZM12.5034 18.7638C11.6382 18.7638 10.9398 18.0653 10.9398 17.2001C10.9398 16.3349 11.6382 15.6365 12.5034 15.6365C13.3686 15.6365 14.0671 16.3349 14.0671 17.2001C14.0671 18.0653 13.3686 18.7638 12.5034 18.7638Z",
  fill: "url(#paint0_linear_807_49985)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.461 6.25459C11.461 5.68125 11.9301 5.21216 12.5034 5.21216C13.0768 5.21216 13.5459 5.68125 13.5459 6.25459V12.5092C13.5459 13.0825 13.0768 13.5516 12.5034 13.5516C11.9301 13.5516 11.461 13.0825 11.461 12.5092V6.25459Z",
  fill: "#FF5C00"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5034 18.7638C11.6382 18.7638 10.9398 18.0653 10.9398 17.2001C10.9398 16.3349 11.6382 15.6365 12.5034 15.6365C13.3686 15.6365 14.0671 16.3349 14.0671 17.2001C14.0671 18.0653 13.3686 18.7638 12.5034 18.7638Z",
  fill: "#FF5C00"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_807_49985",
  x1: 12.5,
  y1: 0,
  x2: 12.5,
  y2: 21.8806,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.005,
  stopColor: "#FBE261"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F1A738"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alert_icon.2b90a68a00b033dbb7446a5dcfaca7fe.svg";